/** @module imports/history */
import { createBrowserHistory } from 'history';
import { canUseDOM } from 'exenv'

/**
 * @function
 * @return {string} baseurl
 * @private
 */


/**
 * history object to control browser routing
 * @constant {History} history
 */

let history = null;
if (canUseDOM) {
    history = createBrowserHistory({
        // basename: getBasename(),
    });
}
export default history;